import { ActionTree, MutationTree, GetterTree, ModuleTree } from 'vuex'
import { IRootState } from '@/services/store/store.types'

/**
 * Entities used across application
 */
export enum EEntities {
  MAILBOXES = 'mailboxes',
  PROJECTS = 'projects',
}

export enum SpamTypes {
  NOT_SPAM,
  POTENTIAL_SPAM,
  SPAM,
}

export enum StatusTypeValues {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum SortOptionValues {
  UPDATED_RECENT = 'updated-recent',
  UPDATED_OLDEST = 'updated-oldest',
  CREATED_RECENT = 'created-recent',
  CREATED_OLDEST = 'created-oldest',
  DUE_DATE = 'due-date',
  TITLE = 'title',
  STATUS = 'status',
  ASSIGNEE = 'assignee',
  PRIORITY = 'priority',
}

export enum DefaultFilterIDs {
  UNASSIGNED = 1,
  DUE_NOW = 2,
  ASSIGNED_TO_YOU = 3,
  YOURE_WATCHING = 4,
  ASSIGNED_TO_OTHERS = 5,
  ACTIVE = 6,
  INACTIVE = 7,
  EVERYTHING = 8,
  SPAM = 9,
  CREATED_BY_YOU = 10,
}

export enum DueTypeValues {
  ANYTIME = 1,
  DUE_NOW = 2,
  THIS_WEEK = 3,
  DATE_RANGE = 4,
}

/* Master order for all default filter nav items */
export const DefaultFilterNavItemsOrder = [
  'Everything',
  'Active',
  'Assigned to You',
  'Created by You', // Tasks/projects only
  `You're Watching`,
  'Due Now',
  'Assigned to Others',
  'Unassigned',
  'Inactive',
  'Spam', // Convos/mailboxes only
]

export const DefaultNamedFilterIcons = [
  {
    label: 'Active',
    icon: 'active',
    indented: false,
  },
  {
    label: 'Assigned to You',
    icon: 'profile',
    indented: true,
  },
  {
    // Projects only :(
    label: 'Created by You',
    icon: 'edit',
    indented: true,
  },
  {
    label: 'Due Now',
    icon: 'today',
    indented: true,
  },
  {
    label: 'Unassigned',
    icon: 'unassigned',
    indented: true,
  },
  {
    label: `You're Watching`,
    icon: 'watching',
    indented: true,
  },
  {
    label: 'Assigned to Others',
    icon: 'people',
    indented: true,
  },
  {
    label: 'Inactive',
    icon: 'inactive',
    indented: false,
  },
  {
    label: 'Everything',
    icon: 'everything',
    indented: false,
  },
  {
    // For mailboxes only
    label: 'Spam',
    icon: 'spam',
    indented: false,
  },
]

/**
 * Used in StoreFactory helper class
 */
export interface IStoreFactoryOptions<S> {
  state?: S
  actions?: ActionTree<S, IRootState>
  mutations?: MutationTree<S>
  getters?: GetterTree<S, IRootState>
  modules?: ModuleTree<IRootState>
}
export interface IDynamicObject {
  [key: string]: string
}
